import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import numeral from "numeral";
import { Tooltip } from "antd";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { FEATURE_TOGGLE_AUTHORIZE } from "../../config";
import DeadlinesIconRenderer from "./deadlinesIconRenderer";

import "./style.css";

/** renderizza la riga usata sia nel widget che nelle lista accanto al calendario */
class RowListDeadlines extends Component {
  static propTypes = {
    navigate: PropTypes.any,
    compensation: PropTypes.string,
    data: PropTypes.string,
    description: PropTypes.string,
    fromSchedaCliente: PropTypes.bool,    
    id: PropTypes.string,
    isArchived: PropTypes.bool,
    isHideBtn: PropTypes.bool,
    myType: PropTypes.string,
    paymentStatus: PropTypes.string,
    status: PropTypes.object,
    title: PropTypes.node,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    today: PropTypes.string,
    tomorrow: PropTypes.string,
    yesterday: PropTypes.string,
    isToPay: PropTypes.bool,
    isPaied: PropTypes.bool,
    isToCashIn: PropTypes.bool,
    isCashed: PropTypes.bool,
    isAuthorized: PropTypes.bool,
    isRejected: PropTypes.bool,
    isCompensated: PropTypes.bool,
    isPayingCustomer: PropTypes.bool,
    isPayingManager: PropTypes.bool,
    isPayingManagerCharge: PropTypes.bool,
    isSuspended: PropTypes.bool,
    isPending: PropTypes.bool
  };

  setIconType() {
    const {
      isPayingCustomer,
      isPayingManager,
      isPayingManagerCharge
    } = this.props;

    if (!isPayingManagerCharge && !isPayingManager && !isPayingCustomer)
      return null;

    if (isPayingManagerCharge) {
      return "landmark";
    }

    if (isPayingManager) {
      return "briefcase";
    }

    if (isPayingCustomer) {
      return "user";
    }
    return undefined;
  }

  setIconColor() {
    const {
      isToPay,
      isPaied,
      isToCashIn,
      isCashed,
      isAuthorized,
      isRejected,
      isCompensated,
      isSuspended,
      isPayingCustomer,
      isPayingManager,
      isPayingManagerCharge,
      isPending
    } = this.props;

    if (isPending){
      return "rgb(253, 185, 39)"; // giallo
    }

    if (!isPayingManagerCharge && !isPayingManager && !isPayingCustomer)
      return null;

    if (isPayingManagerCharge) {
      if (isPaied) return "rgb(9, 130, 42)";// verde
      if (isAuthorized || !isAuthorized) return "rgb(253, 185, 39)";// giallo
    }

    if (isPayingManager) {
      if (isPaied) return "rgb(9, 130, 42)";// verde
      if (isAuthorized || !isAuthorized || isToPay) return "rgb(253, 185, 39)";// giallo
    }

    if (isPayingCustomer) {
      if (isPaied || isCashed || isCompensated) return "rgb(9, 130, 42)";// verde
      if (isToCashIn || isToPay) return "rgb(253, 185, 39)";// giallo
      if (!isPaied || isSuspended || isRejected) return "rgb(216, 40, 41)";// rosso
    }
    return undefined;
  }

  render() {
    const {
      data,
      description,
      fromSchedaCliente,
      id,
      myType,
      status,
      title,
      total,
      today,
      tomorrow,
      yesterday,
      navigate
    } = this.props;
    
    const date = moment(data).format(DATE_FORMAT_FOR_DISPLAY);
    const type = this.setIconType();
    const color = this.setIconColor();

    return (
      <div
        className={
          status && status.confirmed === true
            ? "containerFlex"
            : "containerFlexGrey"
        }
        style={{
          padding: "8px",
          borderBottom: "1px solid #eaeaf5"
        }}
      >
        <div
          className="columnFlexPx"
          style={{ padding: "0 8px", lineHeight: "20px" }}
        >
          <div>
            <b
              className="rowListDate"
              style={{
                color: status?.confirmed === false && "rgb(157, 166, 173)"
              }}
            >
              {date === today
                ? "Oggi"
                : date === tomorrow
                  ? "Domani"
                  : date === yesterday
                    ? "Ieri"
                    : date}
            </b>
            <br />
            {status && status?.confirmed === true ? (
              <b
                className="rowListDescriptionText"
                style={{
                  color: status?.confirmed === false && "rgb(157, 166, 173)"
                }}
              >
                {numeral(Math.abs(total)).format("0,0.00")} €
              </b>
            ) : null}
            <br />
            {FEATURE_TOGGLE_AUTHORIZE === "true" ? (
              <b
                className={
                  status && status?.rejected
                    ? "deadlines-rowList-rejected"
                    : "deadlines-rowList-authorized"
                }
              >
                {status && status?.authorized && "Autorizzato"}
                {status && status?.rejected && "Rifiutato"}
              </b>
            ) : null}
          </div>
        </div>
        {status?.confirmed === true ? (
          <div
            className="columnFlex10"
            style={{
              margin: type !== null ? "10px 40px 0 10px" : "10px 40px 0 -40px"
            }}
          >
            <DeadlinesIconRenderer type={type} color={color} />
          </div>
        ) : (
          <div
            className="columnFlex10"
            style={{
              margin: type !== null ? "10px 40px 0 10px" : "10px 40px 0 -40px"
            }}
          ></div>
        )}

        <div
          className="columnFlex80"
          style={{ paddingRight: "16px", lineHeight: "20px" }}
        >
          <div className="textTruncate">
            <Tooltip placement="left" title={title} color={"rgb(0, 80, 117)"}>
              <b
                className="rowListTextTruncate"
                style={{
                  color: status?.confirmed === false && "rgb(157, 166, 173)"
                }}
              >
                {title}
              </b>
            </Tooltip>
          </div>

          <div className="textTruncate" style={{ fontWeight: "normal" }}>
            <Tooltip
              color={"rgb(0, 80, 117)"}
              className="rowListDescriptionText"
              placement="left"
              title={description}
            >
              {description}
            </Tooltip>
          </div>
        </div>
        {status && status?.confirmed === true ? (
          <div className="columnFlex10">
            <Tooltip
              color={"rgb(0, 80, 117)"}
              placement="left"
              title={"Vai al dettaglio"}
              onClick={e => {
                fromSchedaCliente
                  ? navigate(`/scadenza/${id}?from=${
                    myType === "STUDIO" ? "scheda_cliente" : "dashboard"
                  }`)
                  : navigate({
                    pathname: `/scadenza/${id}`,
                    state: { fromSchedaCliente: true }
                  });
              }}
            >
              <FontAwesomeIcon
                icon={["fas", "arrow-right"]}
                style={{ color: "#0090d1", cursor: "pointer" }}
              />
            </Tooltip>
          </div>
        ) : null}
      </div>
    );
  }
}

export default RowListDeadlines;
